import { Component } from '@angular/core';

@Component({
  selector: 'app-print-layout-header',
  templateUrl: './print-layout-header.component.html',
  styleUrls: ['./print-layout-header.component.css']
})
export class PrintLayoutHeaderComponent {

}
